import { getAuthUser } from "../helpers/auth";

const useOffices = () => {
    const user = getAuthUser();
    const user_offices: { id: number, name: string }[] = user?.office_ids?.map((office: any) => ({
        id: office.id,
        name: office.name
    })) || [];
    const user_office_ids: number[] = user?.office_ids?.map((office: any) => office.id) || [];
    return {
        user_offices,
        user_office_ids,
        hasOfficeId: (office_id: any) => user_office_ids?.includes(office_id)
    };
};


export default useOffices;
